import {
    Box,
    Center,
    chakra,
    GridItem,
    Image,
    SimpleGrid,
    Text,
  } from '@chakra-ui/react';
  import netlify from "../assets/netlify.png"
  import postman from "../assets/postman.png"
  import git from "../assets/git.png"
  import vscode from "../assets/vscode.png"
  import github from "../assets/github.png"
  import render from "../assets/render.png"
  import mongo_altas from "../assets/mongo-atlas.png"
  import npm_ from "../assets/npm_.png"



export default function Tools() {
    return (
      <Box maxW="7xl" mx={'auto'} pt={5} px={{ base: 2, sm: 12, md: 17 }} mt={'100px'}>
        <chakra.h1
         textAlign={'center'}
         fontSize={{base:"2xl",lg:"4xl"}}
         fontWeight={'bold'}
         bg={'teal'}
         color={'white'}
         w={'50%'}
         h='50px'
         rounded="2xl"
         m={'auto'}
         mb={'50px'}>
          Tools
        </chakra.h1>
        <SimpleGrid columns={{ base: 2, md:3, lg:4 }} spacing={{ base: 3, lg: 5 }} fontWeight={'bold'} fontSize={'2xl'} w={'80%'} m={'auto'}>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={vscode}></Image>
              </Center>
              <Text>Vs-code</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={github}></Image>
              </Center>
              <Text>Github</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
               <Image src={git}></Image>
               </Center>
               <Text>Git</Text>
               </GridItem>
               <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'> 
              <Center>
              <Image src={mongo_altas}></Image>
              </Center>
              <Text>MongoDb Atlas</Text>
              </GridItem>
              <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
               <Image bg={'white'} rounded={'full'} src={npm_}></Image>
               </Center>
               <Text>NPM</Text>
               </GridItem> 
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'> 
              <Center>
              <Image src={netlify}></Image>
              </Center>
              <Text>Netlify</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={postman}></Image>
              </Center>
              <Text>Postman</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
               <Image bg={'white'} rounded={'full'} src={render}></Image>
               </Center>
               <Text>Render</Text>
               </GridItem>
        </SimpleGrid>
      </Box>
    );
  }